import React from 'react'
import styled, { keyframes } from 'styled-components'

import { VisuallyHidden } from '../../../utils/style'

import promoBg from '../../../images/promo-bg.png'
import promoCutout from '../../../images/promo-cutout.png'

export const PromoEl = styled(({ expanded, setRef, ...rest }) => (
  <div {...rest} ref={setRef} />
))`
  * {
    padding: 0;
    margin: 0;
  }

  overflow: hidden;
  min-width: 180px;
  height: 48px;
  position: fixed;
  bottom: 16px;
  left: 16px;
  background-color: ${(props) => props.theme.colors.blue};
  background-image: linear-gradient(
    -47deg,
    ${(props) => props.theme.colors.lighter_blue} 34%,
    ${(props) => props.theme.colors.blue} 100%
  );
  color: ${(props) => props.theme.colors.white};
  font-size: 16px;
  border-radius: 80px;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
  transition: all 300ms cubic-bezier(0.165, 0.84, 0.44, 1);
  z-index: 1200;

  @media (min-width: 420px) {
    width: 225px;
    height: 280px;
    border-radius: 8px;
    background-image: linear-gradient(
      125deg,
      ${(props) => props.theme.colors.lighter_blue} 0%,
      ${(props) => props.theme.colors.blue} 94%
    );
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-image: url(${promoBg});
    background-size: cover;
  }

  ${(props) =>
    props.expanded &&
    `
    right: 8px;
    bottom: 8px;
    border-radius: 16px 16px 8px 8px;
    height: 400px;
    width: ${400 * 0.5625}px;

    @supports (width: min(1px, 2px)) {
      width: min(calc((100vh - 16px) * 0.5625), calc(100vw - 16px));
      height: min(calc(100vh - 96px), calc((100vw - 16px) * 1.7777));
    }

    @media (min-width: 420px) {
      left: 8px;
      right: auto;
      height: 570px;
      width: ${570 * 0.5625}px;
      border-radius: 8px;
    }
  `}
`

export const promoContentFade = keyframes`
  0%,
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const PromoInner = styled.button`
  cursor: pointer;
  background: transparent;
  border: 0;
  width: 100%;
  height: 100%;
`

export const PromoInnerInner = styled.div`
  position: relative;
  background-size: 56%;
  background-position: -18px -5px;
  background-repeat: no-repeat;
  background-image: url(${promoCutout});
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  animation: ${promoContentFade} 500ms cubic-bezier(0.165, 0.84, 0.44, 1)
    forwards;

  @media (min-width: 420px) {
    background-position: 30px 40px;
    background-size: 298px auto;
    align-items: flex-start;
  }
`

export const PromoDismiss = styled(({ expanded, ...rest }) => (
  <div {...rest} />
))`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 32px;
  height: 32px;
  align-items: center;
  justify-content: center;
  display: none;

  @media (min-width: 420px) {
    display: flex;
  }

  ${(props) =>
    props.expanded &&
    `
    display: flex;
  `}
`

export const PromoContent = styled.div`
  padding-right: 16px;
  padding-left: 40px;
  text-align: right;
  flex: 1 0 100%;

  @media (min-width: 420px) {
    max-width: 80%;
    text-align: left;
    padding: 12px 16px 16px;
  }
`

export const PromoTitle = styled.h3`
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
  font-size: 14px;
  transform: translateY(-2px);
  color: ${(props) => props.theme.colors.white};

  @media (min-width: 420px) {
    transform: none;
    white-space: auto;
    font-size: 16px;
  }
`

export const PromoSubTitle = styled.p`
  display: none;
  font-weight: 400;
  line-height: 1.5;
  font-size: 14px;
  color: ${(props) => props.theme.colors.white};

  @media (min-width: 420px) {
    display: block;
    font-size: 16px;
  }
`

export const PromoButton = styled(({ dim, ...rest }) => <button {...rest} />)`
  cursor: pointer;
  background: transparent;
  border: 0;
  vertical-align: baseline;
  height: 32px;
  min-width: 32px;
  white-space: nowrap;
  display: inline-block;
  border-radius: 50%;

  color: ${(props) =>
    props.dim ? `rgba(255, 255, 255, 0.5)` : `rgba(255, 255, 255, 1)`};

  &:focus,
  &:hover {
    text-decoration: none;
    outline: 0; /* TODO: something better here */
    background-color: rgba(255, 255, 255, 0.2);
    color: ${(props) => props.theme.colors.white};
  }
`

export const PromoButtonInner = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;

  svg {
    width: 24px;
    height: 24px;
    vertical-align: top;
    fill: currentColor;
  }
`

export const PromoButtonLabel = styled.span`
  ${VisuallyHidden}
`
